<div>
	<div class="row" style="position:relative;top:30px;">
		<div class="" style="margin:auto;">
			<h3 style="white-space: pre-line;">{{message}}</h3>
			<div *ngIf="isVerified&&isSettingFinished" style="text-align:center;text-decoration: underline;font-size:20px;">
				<a [routerLink]="['/auth/login']" target="_blank">Login</a>
			</div>
		</div>
	</div>
	<div *ngIf="isVerified&&!isSettingFinished" class="auth-wrapper">
		<div class="auth-logo">
			<img [src]="imgUrl" class="auth-logo-img">
		</div>
		<form #resetForm="ngForm" name="resetForm">
		<div class="auth-title">
			<label>Set Password</label>
		</div>				
		<div>
			<input type="password" name="password" class="field-vertical" 
				[(ngModel)]="password" 
				placeholder="Please enter new password"  
				appValidateEqual="rePassword" reverse="true" 
				required />
			<input type="password" name="rePassword" class="field-vertical" 
				[(ngModel)]="rePassword" 
				placeholder="Please re-enter new password" 
				appValidateEqual="password" 
				required />
		</div>
			<div class="btn-bottom-wrap">
				<button class="button-general" (click)="setPw()" [disabled]="!this.resetForm.valid || isSetting">OK</button>	
			</div>
		</form>
	</div>
</div>